export interface FetcherError<T = unknown> extends Error {
    info?: T;
    status?: number;
}

export default async function OpenFetcher(route: string | string[], instanceHost?: string) {
    const parsedRoute = Array.isArray(route) ? route[0] : route;

    const res = await fetch(`${instanceHost ?? ''}/api/${parsedRoute}`);

    if (!res.ok) {
        const error: FetcherError = new Error('An error occurred while fetching the data.');
        // Attach extra info to the error object.
        error.info = await res.json();
        error.status = res.status;
        throw error;
    }

    if (res.status === 204) {
        return;
    }

    return res.json();
}
